import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeModel, ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, PermissionService, ValidatorsService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';
import { ProductAttributesEditValidator } from './products-attributes-edit.validator';

@Component({
  selector: 'app-products-attributes-edit',
  templateUrl: './products-attributes-edit.component.html',
  styleUrls: ['./products-attributes-edit.component.css']
})
export class ProductsAttributesEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  language: string;
  loading: boolean;
  attributes: any[] = [];
  products: any[] = [];
  productsIds: string[] = [];
  attributesData: any = null;
  defaultStyle: boolean
  attrID: string


  form: UntypedFormGroup = this.fb.group({
    attribute: ['', this.validator.attribute],
    attribute_value: ['']
  })

  @Input() set data(value) {

    console.log("IDS: ", value);
    

    if (value != null) {

      this.productsIds = value.product_ids;

      this.defaultStyle = value.defaultStyle;

      this.attrID = value.attrsData;

  
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiAttributes: ApiAttributesService,
    public activeModal: NgbActiveModal,
    private notification: NotificationService,
    private validatorService: ValidatorsService,
    private validator: ProductAttributesEditValidator,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(

      this.form.get('attribute').valueChanges.subscribe(val => {

        console.log("VAL: ", val);
        

        val != null ? this.attributesData = val : this.form.get('attribute_value').setValue('');

      })
    )

    // if (this.permissionAccess.check('REFERENCES_ATTRIBUTES')) {

      this.getAttributes();

    // }
    
  }


  /**
  * 
  */
  getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',

      filter: {
        type: ['INPUT', 'TEXTAREA', 'COMBOBOX', 'COMBOBOX_MULTIPLE']
      }
    }

    this.subscriptions.add(
      this.apiAttributes.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("RESPONSE: ", response);


        if (response != null) {

          this.attributes = response.result;

          if (!this.defaultStyle) {

            this.form.get('attribute').setValue(this.attrID);
    
          }
        }
      })
    );

  }

  /**
   * 
   */
  updateList(event) {

    console.log("EVENT: ", event);

    this.form.get('attribute_value').setValue(event.value);

  }


  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    let data: any = {
      product_id: this.productsIds,
      attribute_id: form.attribute.id,
      attribute_group_id: form.attribute.attribute_group_id,
      attribute_value: form.attribute.present_type_id == 'COMBOBOX_MULTIPLE' || form.attribute.present_type_id == 'COMBOBOX' ? String(form.attribute_value) : form.attribute_value //form.attribute_value
    }

    console.log("FORM: ", data);

    this.subscriptions.add(
      this.apiAttributes.attributeUpdate(data).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
    * 
    * @param field 
    * @param type 
    */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
